module.exports = __webpack_public_path__ + "img/start.50c64e91.svg";